import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ReturnsApi from '../../../API/shipment/returns-api';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1 } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD, MAP_SKLAD_RUS, SKLAD_LIST, TO_ONE_RETURN_RECEIVE } from '../../../constans';
import { getDate } from '../../../utils/index';
import styles from './styles.module.scss';
import { NavLink } from '../../../components/Basic/Elements';

export const WIDTH = [
  '150px', // 0
  '400px', // 1
  '140px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
  '210px', // 13
];

function ReturnsPage() {
  const user = useSelector((store) => store.user);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [skladReturn, setSkladReturn] = useState(SKLAD_LIST[0]);
  const [shipmentsSelect, setShipmentsSelect] = useState({});

  const [returns, setReturns] = useState([]);

  const [page, setPage] = useState(1);
  const [show, setShow] = useState(20);
  const [tab, setTab] = useState(0);
  const [date, setDate] = useState(null);

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const changeShipmentsSelect = (number) => {
    if (shipmentsSelect[number]) {
      const s = shipmentsSelect;
      delete s[number];
      setShipmentsSelect({ ...s });
    } else {
      setShipmentsSelect({ ...shipmentsSelect, [number]: true });
    }
  };

  const params = useMemo(() => {
    return {
      //tab: FILTER[tab],
      limit: parseInt(show),
      skladName: skladReturn === 'Все' ? undefined : MAP_SKLAD_RUS[skladReturn],
    };
  }, [tab, show, skladReturn]);

  const loadData = () => {
    ReturnsApi.getReturnDateReceive({ data: params })
      .then((res) => {
        const { returnDateReceives } = res;

        setReturns(returnDateReceives);
      })
      .catch();
  };

  useEffect(() => {
    loadData();
  }, [params]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <Content>
      <H1>Возвраты</H1>

      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все занесения возвраты', 'Обработаны', 'Не обработаны']}
            isNum={false}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>

        <Row spaceBetween={true} style={{ marginTop: '25px' }}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>
            <Select
              list={[...SKLAD_LIST]}
              select={skladReturn}
              label="Склад возврата"
              onSelect={(v) => setSkladReturn(v)}
              width={'200px'}
              style={{ marginRight: '15px' }}
            />
            <Column style={{ marginRight: '15px' }}>
              <InputLabel>Дата возврата</InputLabel>
              <Row style={{ position: 'relative', width: '150px' }}>
                <DateInput value={date} className={styles.calendar} onChange={(v) => setDate(v)} />
                <Button className={styles.close_button} onClick={() => setDate(null)}>
                  <img src={close} style={{ width: '15px' }} />
                </Button>
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>

      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH[9]} centerText />

          <HeaderTitle width={WIDTH[12]} centerText>
            Номер
          </HeaderTitle>
          <HeaderTitle width={WIDTH[2]} centerText>
            Дата возврата
          </HeaderTitle>
          <HeaderTitle width={WIDTH[10]} centerText={true}>
            Количество
          </HeaderTitle>
          <HeaderTitle width={WIDTH[4]} centerText={true}>
            Статус занесения
          </HeaderTitle>
          <HeaderTitle width={WIDTH[4]} centerText={true}>
            Склад
          </HeaderTitle>
        </TableHeader>
        {returns.map((return_part) => {
          return (
            <TableLine key={return_part.id}>
              <TableCell width={WIDTH[9]}>
                <CheckButton
                  checked={shipmentsSelect[return_part.id]}
                  onSelect={() => changeShipmentsSelect(return_part.id)}
                />
              </TableCell>
              <TableCell width={WIDTH[12]} center>
                {return_part.id}
              </TableCell>
              <TableCell width={WIDTH[2]} center>
                <NavLink to={TO_ONE_RETURN_RECEIVE(return_part.id)} className={styles.line_table_link}>
                  {getDate(return_part.date_receive)}
                </NavLink>
              </TableCell>
              <TableCell width={WIDTH[10]} center>
                {return_part.count}
              </TableCell>
              <TableCell width={WIDTH[4]} center>
                в работе
              </TableCell>
              <TableCell width={WIDTH[4]} center>
                {MAP_SKLAD[return_part.skladName]}
              </TableCell>
            </TableLine>
          );
        })}
      </Table>
      {/*  <TableNavigate num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} /> */}
    </Content>
  );
}

export default ReturnsPage;
